import { apiFetch } from './client';
import type { CustodyRow, CustodyType } from '$lib/types';

export interface CustodyBody {
  type?: CustodyType;
  name?: string;
  holder_id?: number;
  // second_holder_id: 0 clears it, omit to leave alone (see custody.go's
  // custodyRequest for why 0 rather than a separate "clear" flag).
  second_holder_id?: number;
  last_verified?: string;
}

// custodyApi backs the Continuity module's custody register (Phase 3) —
// surfaced entirely on the person detail page, no top-level screen. Every
// route is admin-only server-side (see internal/api/handlers/custody.go).
export const custodyApi = {
  list: () => apiFetch<CustodyRow[]>('/admin/continuity/custody'),
  create: (body: CustodyBody) => apiFetch<CustodyRow>('/admin/continuity/custody', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: CustodyBody) =>
    apiFetch<CustodyRow>(`/admin/continuity/custody/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/continuity/custody/${id}`, { method: 'DELETE' })
};
